module.exports = __webpack_public_path__ + "static/media/image-thumb-2.2e6b512e.jpeg";